import ObjCommon from "model/common/ObjCommon";

export class DlUnit extends ObjCommon {
  slug: string = "";
  uType: string = "";
  num: number = 0;
  fold: string = "";
  fVals: { [key: string]: string } = {};
  scans: any[] = [];
  pdf: string = "";

  //   constructor(id: any) {
  //     super(id);
  //   }

  constructor(args: Partial<DlUnit> = {}) {
    super(args?.id); // Call ObjCommon's constructor, passing id if present

    this.slug = args?.slug ?? "";
    this.uType = args?.uType ?? "";
    this.num = args?.num ?? 0;
    this.fold = args?.fold ?? "";
    this.fVals = args?.fVals ? { ...args.fVals } : {};
    this.scans = args?.scans ? [...args.scans] : [];
    this.pdf = args?.pdf ?? "";
  }

  fValGet(fNam: string): string {
    let fVal = "";
    if (Object.prototype.hasOwnProperty.call(this.fVals, fNam)) {
      fVal = this.fVals[fNam];
    }
    return fVal;
  }

  unitTitleGet(): string {
    let title = "";
    title += this.fValGet("200_a");
    if (title !== "") {
      const f200e = this.fValGet("200_e");
      title += (f200e !== "" ? ", " : "") + f200e;
    }
    return title;
  }
}
